import type { ToastMessageOptions } from 'primevue/toast';
import type { actionMessageType } from '../options';
import { GraphQLError } from 'graphql';

export function createMessage(
    defaultMessage: ToastMessageOptions,
    entityTypename: string | undefined,
    entityName: string | null | undefined
) {
    return {
        ...defaultMessage,
        severity: 'success',
        summary: entityTypename ? `${entityTypename} opgeslagen` : 'Opgeslagen',
        detail: entityName
            ? `${entityName} is toegevoegd`
            : 'Object is toegevoegd',
    } as ToastMessageOptions;
}

export function updateMessage(
    defaultMessage: ToastMessageOptions,
    entityTypename: string | undefined,
    entityName: string | null | undefined
) {
    return {
        ...defaultMessage,
        severity: 'info',
        summary: entityTypename ? `${entityTypename} opgeslagen` : 'Opgeslagen',
        detail: entityName
            ? `${entityName} is aangepast`
            : 'Object is aangepast',
    } as ToastMessageOptions;
}

export function deleteMessage(
    defaultMessage: ToastMessageOptions,
    entityTypename: string | undefined,
    entityName: string | null | undefined
) {
    return {
        ...defaultMessage,
        severity: 'warn',
        summary: entityTypename ? `${entityTypename} verwijderd` : 'Verwijderd',
        detail: entityName
            ? `${entityName} is verwijderd`
            : 'Object is verwijderd',
    } as ToastMessageOptions;
}

export function connectMessage(
    defaultMessage: ToastMessageOptions,
    entityName: string | null | undefined
) {
    return {
        ...defaultMessage,
        severity: 'info',
        summary: 'Connectie gemaakt',
        detail: entityName
            ? `${entityName} heeft nieuwe connecties`
            : 'De koppeling is opgeslagen',
    } as ToastMessageOptions;
}

export function errorMessage(
    defaultMessage: ToastMessageOptions,
    actionType: actionMessageType | string,
    error?: readonly GraphQLError[] | Error | string
) {
    let errorMessage: string;

    if (typeof error === 'string') {
        errorMessage = error;
    } else if (error instanceof Error) {
        errorMessage = error.message;
    } else if (Array.isArray(error)) {
        errorMessage = error
            .map((graphQLError) => graphQLError.message)
            .join(', ');
    } else {
        errorMessage = 'An unknown error occurred';
    }

    return {
        ...defaultMessage,
        severity: 'error',
        summary: `${actionType} mislukt`,
        detail: errorMessage,
    } as ToastMessageOptions;
}
